// Общий выбор WB или Ozon для шапки, меню и страниц.
// Без импортов api/http.js и axios: модуль проверяется тестами Jest.

export const SELECTED_MARKETPLACE_STORAGE_KEY = "uprasti:selected-marketplace";
export const MARKETPLACE_CHANGE_EVENT = "uprasti:marketplace-change";

export function getMarketplaceFromPath(pathname) {
  const path = String(pathname || "");
  if (path.startsWith("/ozon")) return "ozon";
  if (path.startsWith("/wildberries")) return "wb";
  return null;
}

// Префикс адреса, затем сохранённый выбор, затем Ozon.
export function resolveInitialMarketplace(pathname, storage) {
  const routeMarketplace = getMarketplaceFromPath(pathname);
  if (routeMarketplace) return routeMarketplace;
  try {
    const saved = (storage || window.localStorage).getItem(
      SELECTED_MARKETPLACE_STORAGE_KEY
    );
    if (saved === "wb" || saved === "ozon") return saved;
  } catch (_) {}
  return "ozon";
}

export function saveSelectedMarketplace(marketplace) {
  try {
    window.localStorage.setItem(SELECTED_MARKETPLACE_STORAGE_KEY, marketplace);
  } catch (_) {}

  window.dispatchEvent(
    new CustomEvent(MARKETPLACE_CHANGE_EVENT, {
      detail: { marketplace },
    })
  );
}
